module.exports = __webpack_public_path__ + "img/financial.6671d687.svg";